var map = {
	"./renders/CopyButton/index.js": 8039,
	"./renders/DefaultAssignmentPlans/index.js": 8606,
	"./renders/InheritableAssignmentPlan/index.js": 8044,
	"./renders/PeerNomLockReset/index.js": 8045,
	"./renders/PercentComplete/index.js": 8046,
	"./renders/Rescore/index.js": 8607,
	"./renders/StudentLauncher/index.js": 8047,
	"./renders/UploadImage/index.js": 696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1337;